// src/api/teamMemberApi.js
// Wraps the Spring backend's /teammember endpoint (com.experience.teammember.TeamMemberController).
import axiosClient from "./axiosClient";

export const getTeamMembers = async (teamId) => {
  const response = await axiosClient.get("/teammember", {
    params: {
      teamId,
    },
  });

  return response.data;
};

export const addTeamMember = async ({ userId, teamId }) => {
  const response = await axiosClient.post("/teammember", {
    userId,
    teamId,
  });

  return response.data;
};

export const getMemberCountByOrganization = async (organizationId) => {
  const response = await axiosClient.get("/teammember/count", {
    params: { organizationId },
  });

  return response.data;
};

export const isTeamMember = async (teamId) => {
  const response = await axiosClient.get("/teammember/ismember", {
    params: { teamId },
  });

  return response.data;
};

export const hasEmailConflict = async ({ teamId, email }) => {
  const response = await axiosClient.get("/teammember/emailconflict", {
    params: { teamId, email },
  });

  return response.data;
};

// Joins the caller (from the auth token) to a team and links their account
// to its organization. Returns { ok, error }.
export const joinTeam = async ({ teamId, organizationId }) => {
  const response = await axiosClient.post("/teammember/join", {
    teamId,
    organizationId,
  });

  return response.data;
};

// Roster across every team in an org - only returned if the caller belongs to it.
export const getTeamMembersByOrganizationId = async (organizationId) => {
  const response = await axiosClient.get("/teammember/byorganization", {
    params: { organizationId },
  });
  return response.data;
};

// Finds the team the caller's own (token-verified) email belongs to.
// Returns { teamId, organizationId }, or null if not a member of any team.
export const getOwnMembership = async () => {
  try {
    const response = await axiosClient.get("/teammember/byemail");
    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) {
      return null;
    }
    throw error;
  }
};
